import { useCallback, useState } from "react";

const SHOW_GITHUB_KEY = "staffActivities.showGithub";

/**
 * #1404: interruptor «Issues de GitHub» del backlog y del tablero. Se recuerda
 * en el navegador; apagado por omisión (el backlog muestra lo del equipo).
 */
export function useShowGithub(): [boolean, (next: boolean) => void] {
  const [show, setShow] = useState<boolean>(() => {
    try {
      return window.localStorage.getItem(SHOW_GITHUB_KEY) === "1";
    } catch {
      return false;
    }
  });
  const set = useCallback((next: boolean) => {
    setShow(next);
    try {
      window.localStorage.setItem(SHOW_GITHUB_KEY, next ? "1" : "0");
    } catch {
      // Sin almacenamiento (modo privado): el interruptor vale solo en esta vista.
    }
  }, []);
  return [show, set];
}
